/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ReportsTable_company = {
    readonly id: string;
    readonly " $refType": "ReportsTable_company";
};
export type ReportsTable_company$data = ReportsTable_company;
export type ReportsTable_company$key = {
    readonly " $data"?: ReportsTable_company$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ReportsTable_company">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ReportsTable_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Company"
};
(node as any).hash = 'a6dfa5576852c904ad5d3434ddbe3e9c';
export default node;
